import React, { Fragment } from "react"
import WithPage from "data/wrappers/WithPage"
import Editor from "features/editor"
import { Helmet } from "react-helmet"

export default class PageEditor extends React.Component {
    render() {
        return (
            <WithPage pageId={this.props.params.pageId}>
                {({ page, onChange }) => (
                    <Fragment>
                        <Helmet>
                            <link rel="shortcut icon" href="/favicon.clear.png" type="image/png" />
                            <meta charSet="utf-8" />
                            <title>{page.name} | Stacker</title>
                        </Helmet>
                        <Editor onChange={onChange} page={page} />
                    </Fragment>
                )}
            </WithPage>
        )
    }
}



// WEBPACK FOOTER //
// ./src/features/studio/containers/PageEditor.js